<template>
  <div id="app" class="theme" style="background-color: #efefef;" :style="{ 'background-image': this.$route.name == 'home' ? `url(${baseUrl}images/web-bg.jpg)` : '' }">
    <Header v-if="$route.name != 'login'" />
    <transition name="el-fade-in" mode="out-in">
      <router-view class="wrapper" v-if="(userToken && userData) || this.$route.name == 'login'" />
    </transition>
    <Footer v-if="userData && this.$route.name != 'login'" />
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,

      // hasJur: false,
      // hasOffect: false
    };
  },
  computed: {
    ...mapState(["userToken", "userData", "axiosSwitch", "routeJur"]),
  },
  created() {
    this.$router.afterEach((to, from) => {
      // 用户浏览量计数器
      this.$http
        .post(
          "viewStatistics/add",
          this.$qs.stringify({ viewName: to.name, deviceType: "pc" })
        )
        .then(({ data }) => {})
        .catch(() => {});

      if (from.name == null) {
        if (this.$route.query.token && this.$route.query.gotoUrl) {
          // window.localStorage.setItem('userToken', this.$route.query.token);
          window.sessionStorage.setItem("userToken", this.$route.query.token);
          this.setUserToken(this.$route.query.token)
            .then(() => {
              this.fetchUserData();
              this.$router.push({ path: this.$route.query.gotoUrl });
            })
            .catch(() => {
              this.$router.push({ name: "login" });
            });
        } else if (this.userToken) {
          this.fetchUserData();
        } else if (!this.userToken) {
          this.$router.push({ name: "login" });
        }
      } else {
        if (!this.userToken) {
          this.$router.push({ name: "login" });
        }
      }
    });
  },
  mounted() {},
  methods: {
    ...mapActions(["setUserToken", "fetchUserData", "logout"]),
  },
  filters: {
    arrFrom(arr) {
      return Array.from(arr);
    },
  },
  watch: {
    userToken(value, oldValue) {
      if (!value && oldValue) {
        this.$router.push({ name: "login" });
      }
    },
    axiosSwitch(value) {
      if (value) {
        // console.log("switchOn");
        this.$http.interceptors.response.use(
          (response) => {
            // console.log(response);
            if (response.data.RetCode == 601) {
              this.$notify({
                title: "温馨提示",
                message: "登录超时，请重新登录",
                type: "warning",
                offset: 60,
                duration: 3000,
                onClose: () => {
                  this.logout().then(() => {
                    window.location.reload();
                  });
                },
              });
            } else {
              return response;
            }
          },
          (error) => {
            // console.log(error)
          }
        );
      }
    },
    routeJur(value) {
      if (value) {
        let arr = [];

        // let hasJur = false;
        // if (
        //   value.counts01 ||
        //   value.counts02 ||
        //   value.counts03 ||
        //   value.counts04 ||
        //   value.counts05
        // ) {
        //   arr.push({
        //     path: "/about",
        //     name: "about",
        //     component: () => import("./views/About.vue")
        //   });
        //   hasJur = true;
        // }
        // let hasOffect = false;
        // if (
        //   value.OfficeSubject ||
        //   value.OfficeAttr ||
        //   value.OfficeBusiness ||
        //   value.OfficeSeal ||
        //   value.OfficeSign ||
        //   value.OfficeRoleForDepartment ||
        //   value.OfficeRoleDepartment ||
        //   value.OfficeRoleCollege ||
        //   value.OfficeRoleForHref ||
        //   value.OfficeCollect ||
        //   value.OfficeCar
        // ) {
        //   arr.push({
        //     path: "/office",
        //     name: "office",
        //     component: () => import("./views/Office.vue")
        //   });
        //   hasOffect = true;
        // }
        // this.$nextTick(() => {
        //   this.hasJur = hasJur;
        //   this.hasOffect = hasOffect;
        // });

        let serveCountArr = {
          path: "/serveCount",
          redirect: "/serveCount/byPersonal",
          component: () => import("./views/ServeCount/ServeCount.vue"),
          children: [
            {
              path: "/serveCount/byPersonal",
              name: "byPersonal",
              component: () =>
                import("./views/ServeCount/ByPersonal/ByPersonal.vue"),
            },
          ],
        };
        if (value.counts03) {
          serveCountArr.children.push({
            path: "/serveCount/byCollege",
            name: "byCollege",
            component: () =>
              import("./views/ServeCount/ByCollege/ByCollege.vue"),
          });
          serveCountArr.redirect = "/serveCount/byCollege";
        }
        if (value.counts04) {
          serveCountArr.children.push({
            path: "/serveCount/byDept",
            name: "byDept",
            component: () => import("./views/ServeCount/ByDept/ByDept.vue"),
          });
          serveCountArr.redirect = "/serveCount/byDept";
        }
        if (value.counts01) {
          serveCountArr.children.push({
            path: "/serveCount/byHall",
            name: "byHall",
            component: () => import("./views/ServeCount/ByHall/ByHall.vue"),
          });
          serveCountArr.redirect = "/serveCount/byHall";
        }
        arr.push(serveCountArr);

        let offArr = {
          path: "/office",
          redirect: "/office/officeSign",
          component: () => import("./views/OfficeNew/OfficeNew.vue"),
          children: [
            {
              path: "/office/officeSign",
              name: "officeSign",
              component: () =>
                import("./views/OfficeNew/OfficeSign/OfficeSign.vue"),
            },
            {
              path: "/office/officeSeal",
              name: "officeSeal",
              component: () =>
                import("./views/OfficeNew/OfficeSeal/OfficeSeal.vue"),
            },
          ],
        };
        if (value.OfficeSubject) {
          offArr.children.push(
            {
              path: "/office/officeSubject",
              name: "officeSubject",
              component: () =>
                import("./views/OfficeNew/OfficeSubject/OfficeSubject.vue"),
            },
            {
              path: "/office/OfficeProcess",
              name: "OfficeProcess",
              component: () =>
                import("./views/OfficeNew/OfficeProcess/OfficeProcess.vue"),
            }
          );
        }
        // if (value.OfficeSubject) {
        //   offArr.children.push({
        //     path: "/office/OfficeProcess",
        //     name: "OfficeProcess",
        //     component: () =>
        //       import("./views/OfficeNew/OfficeProcess/OfficeProcess.vue"),
        //   });
        // }
        if (value.OfficeBiz) {
          offArr.children.push(
            {
              path: "/office/officeBiz",
              name: "officeBiz",
              component: () =>
                import("./views/OfficeNew/OfficeBiz/OfficeBiz.vue"),
            },
            {
              path: "/office/officeBizEdit/:id/:serveType",
              name: "officeBizEdit",
              component: () =>
                import("./views/OfficeNew/OfficeBiz/OfficeBizEdit.vue"),
            },
            {
              path: "/office/officeBizException",
              name: "officeBizException",
              component: () =>
                import("./views/OfficeNew/OfficeBiz/OfficeBizException.vue"),
            }
          );
        }
        if (value.OfficeRoleForDepartment) {
          offArr.children.push({
            path: "/office/officeRoleForDepartment",
            name: "officeRoleForDepartment",
            component: () =>
              import(
                "./views/OfficeNew/OfficeRoleForDepartment/OfficeRoleForDepartment.vue"
              ),
          });
        }
        if (value.OfficeRoleDepartment) {
          offArr.children.push({
            path: "/office/officeRoleDepartment",
            name: "officeRoleDepartment",
            component: () =>
              import(
                "./views/OfficeNew/OfficeRoleDepartment/OfficeRoleDepartment.vue"
              ),
          });
        }
        if (value.OfficeRoleCollege) {
          offArr.children.push({
            path: "/office/officeRoleCollege",
            name: "officeRoleCollege",
            component: () =>
              import(
                "./views/OfficeNew/OfficeRoleCollege/OfficeRoleCollege.vue"
              ),
          });
        }
        if (value.OfficeServeGroup) {
          offArr.children.push({
            path: "/office/officeServeGroup",
            name: "officeServeGroup",
            component: () =>
              import("./views/OfficeNew/OfficeServeGroup/OfficeServeGroup.vue"),
          });
        }
        if (value.OfficeRoleForHref) {
          offArr.children.push({
            path: "/office/officeRoleForHref",
            name: "officeRoleForHref",
            component: () =>
              import(
                "./views/OfficeNew/OfficeRoleForHref/OfficeRoleForHref.vue"
              ),
          });
        }
        if (value.OfficeCar) {
          offArr.children.push(
            {
              path: "/office/officeCar",
              name: "officeCar",
              component: () =>
                import("./views/OfficeNew/OfficeCar/OfficeCar.vue"),
            },
            {
              path: "/office/officeCarHistory",
              name: "officeCarHistory",
              component: () =>
                import(
                  "./views/OfficeNew/OfficeCarHistory/OfficeCarHistory.vue"
                ),
            }
          );
        }
        arr.push(offArr);

        this.$router.addRoutes(arr);
      }
    },
  },
};
</script>

<style scoped>
#app {
  min-width: 100%;
  min-height: 100vh;
  background: no-repeat center bottom fixed;
  background-size: cover;
}

.wrapper {
  min-height: calc(100vh - 150px);
}
</style>